<template>
  <background-particles />
  <v-container
    fluid
    class="fill-height bg-secondary"
  >
    <v-row class="d-flex align-center justify-center">
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          v-motion-roll-right
          class="pa-6 pa-md-12 bg-white text-center"
          elevation="24"
        >
          <div v-if="user.emailVerified">
            <div>
              <Vue3Lottie
                :animationData="DoneJSON"
                :width="200"
              />
            </div>
            <div class="mb-6 text-primary text-h5">Verification Complete!</div>
            <div>
              <v-btn
                @click="$router.push('/onboarding')"
                color="primary"
                rounded="lg"
                variant="flat"
              >
                Continue
              </v-btn>
            </div>
          </div>
          <div v-else>
            <div class="mb-6 text-primary text-h4">
              <Vue3Lottie
                :animationData="EmailJSON"
                :width="100"
              />
              Email Verification Required
            </div>
            <div>
              <v-progress-circular
                :size="50"
                :width="3"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div class="my-6 text-primary">
              We've sent an email to <strong>{{ user.email }}</strong> with a
              link to verify your account. Make sure to check your spam!
            </div>
            <div>
              <v-btn
                @click="resendEmail"
                color="primary"
                rounded="lg"
                variant="flat"
              >
                Resend Email
              </v-btn>
            </div>
            <div class="mt-3">
              <v-btn
                @click="logout"
                color="primary"
                rounded="lg"
                variant="flat"
              >
                Back
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
  import BackgroundParticles from "@/components/BackgroundParticles.vue";
  import { sendEmailVerification } from "firebase/auth";
  import { useAlertStore } from "@/store/alert";
  import DoneJSON from "@/assets/done.json";
  import EmailJSON from "@/assets/email.json";
  import { signOut } from "firebase/auth";
  import { useFirebaseAuth, useCurrentUser } from "vuefire";
  const auth = useFirebaseAuth();

  const alertStore = useAlertStore();
  // Keep reloading the user every second to check if they've verified their email
  let user = useCurrentUser();
  let intervalId = setInterval(() => {
    user.value.reload();
    if (user.value.emailVerified) {
      clearInterval(intervalId);
    }
  }, 1000);

  const resendEmail = () => {
    sendEmailVerification(user.value)
      .then(() => {
        alertStore.showAlert("Sent!", "success");
      })
      .catch((error) => {
        console.error("Error sending verification email: ", error);
        alertStore.showAlert(
          "There was an error sending the verification email. Please try again or contact support.",
          "error"
        );
      });
  };
  const logout = () => {
    signOut(auth)
      .then(() => {
        document.cookie =
          "logged-in-ea=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.eye.academy; path=/;";

        // refresh page
        setTimeout(() => {
          window.location.reload();
        }, 100); // 100 milliseconds delay to ensure cookie is deleted
      })
      .catch((error) => {
        console.error("Error signing out: ", error);
        alertStore.showAlert(
          "There was an error logging you out. Please try again or contact support.",
          "error"
        );
      });
  };
</script>
